import React from "react";
import { cleanDate } from "../../../util/app";

function PatientAdmission({ item = null }) {
    if (item)
        return (
            <div className="row fade-in">
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Date & Time</strong>
                                </td>
                                <td>{cleanDate(item.admission_date, false, true)}</td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Discharge Date</strong>
                                </td>
                                <td>{item.discharge_date ? cleanDate(item.discharge_date, true, true) : <strong className="text-danger">Unknown Discharge Date!</strong>}</td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Ward</strong>
                                </td>
                                <td>
                                    <span className="badge badge-primary">{item.bed.room.ward.name}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Room</strong>
                                </td>
                                <td>
                                    <span className="badge badge-primary">{item.bed.room.name}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Bed</strong>
                                </td>
                                <td>
                                    <span className="badge badge-primary">{item.bed.name}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    return (
        <center>
            <h4 className="text-primary">This is Out Patient</h4>
        </center>
    );
}

export default PatientAdmission;
